import { Link } from 'react-router-dom';
import { latestContent } from '@/mocks/home';

export default function LatestUpdates() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              最新上线
            </h2>
            <p className="text-sm text-foreground-500">刚刚更新的热门内容，抢先观看</p>
          </div>
          <Link
            to="/category/movie"
            className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {latestContent.map((item) => (
            <Link
              key={item.id}
              to={`/article/${item.id}`}
              className="group flex gap-4 p-3 md:p-4 rounded-xl bg-background-100 hover:bg-background-200/70 border border-background-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-32 md:w-40 flex-shrink-0 overflow-hidden rounded-lg aspect-video">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                {item.tag && (
                  <span className="absolute top-1.5 left-1.5 px-1.5 py-0.5 rounded text-[10px] font-medium bg-primary-500 text-background-50">
                    {item.tag}
                  </span>
                )}
              </div>
              <div className="flex flex-col justify-between flex-1 min-w-0">
                <div>
                  <div className="flex items-center gap-1.5 mb-1">
                    <span className="text-xs text-primary-500 font-medium">{item.category}</span>
                    <span className="text-xs text-foreground-400">·</span>
                    <span className="text-xs text-foreground-500">{item.subCategory}</span>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 mb-1">
                    {item.title}
                  </h3>
                </div>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <div className="flex items-center gap-1">
                    <div className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-star-fill text-accent-500 text-xs"></i>
                    </div>
                    <span className="font-medium text-foreground-700">{item.rating}</span>
                  </div>
                  <span>{item.updateDate}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}